import React from "react";

export function shouldShowNotification(msg) {
  const { attach } = msg;
  if (!attach) return false;
  if (
    attach.type === "leaveTeam" ||
    attach.type === "addTeamMembers"
  ) return false;
  return true;
}

export default function NotificationMessage({ msg }) {
  const { attach } = msg;
  if (!attach) return null;

  if (attach.type === "updateTeamMute") {
    const myAccount = localStorage.getItem("yx_account");
    const isSelf = attach.account === myAccount;
    const user = attach.users?.find((u) => u.account === attach.account);
    const name = isSelf ? "您" : (user?.nick || attach.account);
    const action = attach.mute === false ? "被管理员解除禁言" : "被管理员禁言";
    return (
      <div className="imc-noti-center">{name + " " + action}</div>
    );
  }

  if (attach.type === "removeTeamMembers") {
    const members = attach.members || attach.teamMembers || [];
    const accounts = attach.accounts || [];
    const allNames = members.length > 0
      ? members.map(m => m.nickInTeam || m.nick || m.account).filter(Boolean)
      : accounts;
    const total = allNames.length || accounts.length || 1;
    const display = total > 1
      ? `${allNames[0] || "成员"}、${allNames[1] || "成员"} 等`
      : (allNames[0] || "成员");
    return (
      <div className="imc-noti-center">{display}被管理员踢出群聊</div>
    );
  }

  if (attach.type === "beReCallMsg") {
    const recaller = attach.account || attach.opeAccount || msg.from;
    const recallNick = attach.nick || recaller;
    const tip = msg.flow === "out" ? "你撤回了一条消息" : `${recallNick} 撤回了一条消息`;
    return (
      <div className="imc-noti-center">{tip}</div>
    );
  }

  return null;
}
